export default __webpack_public_path__ + "images/6db45728369f2743b4e23e83bc8fcd47.png";